import type { KpiEntry } from "@/api/kpi";
import { DeepLink } from "@/components/DeepLink";
import { SortableTable, type ColumnDef } from "@/components/SortableTable";
import { t } from "@/i18n";
import { fmtInt, fmtMoney } from "@/lib/utils";

interface EncokSatanRow extends KpiEntry {
  rank: number;
}

function s(v: unknown): string {
  return v == null ? "" : String(v);
}
function n(v: unknown): number {
  const x = Number(v);
  return Number.isFinite(x) ? x : 0;
}

const columns: ColumnDef<EncokSatanRow>[] = [
  { key: "rank", header: "#", accessor: (r) => String(r.rank) },
  {
    key: "name",
    header: t("ozet.encok_satan.urun"),
    accessor: (r) => (
      <>
        <div className="font-medium">
          <DeepLink href={typeof r.admin_link === "string" ? r.admin_link : undefined} label={s(r.name) || "—"} />
        </div>
        {r.sku ? <div className="font-mono text-[11px] text-muted">{s(r.sku)}</div> : null}
      </>
    ),
  },
  { key: "adet", header: t("ozet.encok_satan.adet"), accessor: (r) => fmtInt(n(r.adet)), sortValue: (r) => n(r.adet) },
  { key: "ciro", header: t("ozet.encok_satan.ciro"), accessor: (r) => fmtMoney(n(r.ciro)), sortValue: (r) => n(r.ciro) },
];

/**
 * Bu haftanın en çok satan ürünleri — eski `app.js:1049-1073 renderTopProducts`
 * portu. Veri `kpis.encok_satan.items` (`kpi_encok_satan` zaten ilk 10'a
 * kırpar — bkz. calculator.py); satır alanları `loaders.py load_urun_satis`:
 * `name`/`sku`/`adet`/`ciro` (legacy'nin `sold_count`/`total_revenue` DEĞİL).
 * `admin_link` loader'da henüz YOK — DeepLink bu durumda düz metne düşer.
 */
export function EncokSatanTablosu({ items }: { items: KpiEntry[] }) {
  const rows: EncokSatanRow[] = items.slice(0, 10).map((it, i) => ({ ...it, rank: i + 1 }));
  return (
    <div data-testid="encok-satan-tablosu">
      <SortableTable columns={columns} rows={rows} rowKey={(r) => String(r.product_card_id ?? r.sku ?? r.rank)} />
    </div>
  );
}
